import { render } from "./Header.vue?vue&type=template&id=2565329e&scoped=true&bindings={\"scrolled\":\"data\",\"enlarged\":\"data\",\"pathMenu\":\"data\",\"handleScroll\":\"options\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2565329e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2565329e"

export default script